<ng-container *ngIf="hasChangelog" class="ion-margin-top">
    <ng-container *ngIf="timezone$ | async as timezone">
        <jobs-placements-changelog-item *ngFor="let item of items" [item]="item" [timezone]="timezone"> </jobs-placements-changelog-item>
    </ng-container>
</ng-container>
